import React from 'react';
import classNames from 'classnames';
import { LogoWhite } from '../SVG';
import { useQlubRouter } from '../../hook/router';
import { ThemeModeEnum } from '../../context/config';

import styles from './index.module.scss';

interface IProps {
    hideIcon?: boolean;
}

export default function SplashLegacy({ hideIcon }: IProps) {
    const { theme } = useQlubRouter();

    return (
        <div
            className={classNames(styles.splash, {
                [styles.black]: theme === ThemeModeEnum.Black,
                [styles.hideLogo]: hideIcon,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.container}>{hideIcon !== true && <LogoWhite className={styles.logo} />}</div>
                <div className={styles.loading}>
                    <div className={styles.kkEllipsis}>
                        <div />
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
            </div>
        </div>
    );
}
